import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';
import { Transition }               from '@uirouter/core';

import { FranchiseAccountsModel }           from './typings/franchise.accounts';
import { FranchiseComponent }               from './franchise.component';
import { FranchiseModel }                   from './typings/franchise';
import { FranchiseOwnerSettingsModel }      from './typings/franchise.owner-settings';
import { FranchisesOwnerSettingsComponent } from './franchises.owner-settings.component';
import { FranchisesService }                from './franchises.service';
import { FranchisesSettingsComponent }      from './franchises.settings.component';

export const FranchisesStates : Array<NgHybridStateDeclaration> = [
  {
    component: FranchisesSettingsComponent,
    name     : 'app.franchise-settings',
    resolve  : [
      {
        deps     : [ FranchisesService ],
        resolveFn: ( franchisesService : FranchisesService ) : ng.IPromise<Array<FranchiseModel>> => franchisesService.getFranchises(),
        token    : 'franchises'
      }
    ],
    url: '/franchise-settings'
  },
  {
    component: FranchiseComponent,
    name     : 'app.franchise',
    params   : {
      id: { squash: true, value: null }
    },
    resolve: [
      {
        deps     : [ FranchisesService ],
        resolveFn: ( franchisesService : FranchisesService ) : ng.IPromise<FranchiseAccountsModel> => franchisesService.getAccounts(),
        token    : 'accounts'
      },
      {
        deps     : [ FranchisesService, Transition ],
        resolveFn: ( franchisesService : FranchisesService, transition : Transition ) : ng.IPromise<FranchiseModel> => franchisesService.get(transition.params().id),
        token    : 'franchise'
      }
    ],
    url: '/franchise/:id'
  },
  {
    component: FranchisesOwnerSettingsComponent,
    name     : 'app.franchise-owner-settings',
    resolve  : [
      {
        deps     : [ FranchisesService ],
        resolveFn: ( franchisesService : FranchisesService ) : ng.IPromise<FranchiseOwnerSettingsModel> => franchisesService.getOwnerSettings(),
        token    : 'settings'
      }
    ],
    url: '/franchise-owner-settings'
  }
];
